import styles from './index.module.less'
import Title from '@/components/BlockTitleTwo'
import icon from '@/assets/image/gea/transaction.svg'
import SearchInput from '@/components/SearchInputTwo'
import BlockTitle from '@/components/BockTitle'
import CardInfo from './components/cardInfo'
import { useTranslation } from 'react-i18next'
import { getRestTxList, getTxsRollappList } from '@/api/transactionList'
import {
  RollappList_Transaction,
  RollappList_TransactionData,
  Transaction,
  TransactionData,
} from '@/api/transactionList/interface'
import { useRequest } from 'ahooks'
import { useMemo, useRef, useState } from 'react'
import LoadingCom from '@/components/LoadingCom'
import MePaginationNew from '@/components/MePaginationNew'
import SlideBtn, { IbtnListItem } from '@/components/SlideBtn'
import MeEmpty from '@/components/MeEmpty'

const Transition = () => {
  const { t } = useTranslation()
  // hub
  const [pageParams, setPageParams] = useState<{
    offset: number
    limit: number
    page: number
  }>({
    offset: 0,
    limit: 10,
    page: 1,
  })

  // rollup
  const [pageParamsRollup, setPageParamsRollup] = useState<{
    offset: number
    limit: number
    page: number
  }>({
    offset: 0,
    limit: 10,
    page: 1,
  })

  // hub
  const hubGroupSize = useRef(0)
  const [total, setTotal] = useState(0)
  const [txList, setTxList] = useState<Transaction[]>([])
  const hubKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  const hubNextKey = useRef('')
  const [hubNextKeyData, setHubNextKeyData] = useState<string>('')
  const hubCurrentGroupIndex = useRef(0)

  // rollup
  const rollupGroupSize = useRef(0)
  const [totalRollup, setTotalRollup] = useState(0)
  const [txListRollup, setTxListRollup] = useState<RollappList_Transaction[]>([])
  const rollupKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  const rollupNextKey = useRef('')
  const [rollupNextKeyData, setRollupNextKeyData] = useState<string>('')
  const rollupCurrentGroupIndex = useRef(0)

  // hub hubPaginationPreAndNext
  const hubPaginationPreAndNext = useMemo(() => {
    return {
      canNext: !!hubNextKeyData,
      canPrev: hubCurrentGroupIndex.current > 0,
    }
  }, [hubNextKeyData, hubCurrentGroupIndex.current])

  //
  const rollupPaginationPreAndNext = useMemo(() => {
    return {
      canNext: !!rollupNextKeyData,
      canPrev: rollupCurrentGroupIndex.current > 0,
    }
  }, [rollupNextKeyData, rollupCurrentGroupIndex.current])

  const [tabList, setTabList] = useState<IbtnListItem[]>([
    {
      name: 'GEA HUB', // hub
      value: 'hub',
      active: true,
    },
    {
      name: 'Rollapp Check-in', // rollup
      value: 'rollup',
      active: false,
    },
  ])

  /** 参数组装 */
  const getPageParams = () => {
    const params: any = {
      offset: pageParams.offset,
      limit: pageParams.limit,
    }
    if (hubKeyArray.current[hubCurrentGroupIndex.current]) {
      params.key = hubKeyArray.current[hubCurrentGroupIndex.current]
    }

    return params
  }

  // hub
  const { loading } = useRequest(() => getRestTxList(getPageParams()), {
    refreshDeps: [pageParams],
    onSuccess: (res: TransactionData) => {
      if (res) {
        setTotal(res.group_data.aggregate.count)
        setTxList(res.transaction)
        hubNextKey.current = res.next_key
        setHubNextKeyData(res.next_key)
        if (hubCurrentGroupIndex.current === 0 && res.next_key) {
          hubGroupSize.current = res.group_data.aggregate.count
        }
      }
    },
  })

  const getRollupPageParams = () => {
    const params: any = {
      offset: pageParamsRollup.offset,
      limit: pageParamsRollup.limit,
    }
    if (rollupKeyArray.current[rollupCurrentGroupIndex.current]) {
      params.key = rollupKeyArray.current[rollupCurrentGroupIndex.current]
    }

    return params
  }

  // rollup
  const { loading: rollupLoading } = useRequest(() => getTxsRollappList(getRollupPageParams()), {
    ready: false,
    refreshDeps: [pageParamsRollup],
    onSuccess: (res: RollappList_TransactionData) => {
      if (res) {
        setTxListRollup(res.transaction)
        setTotalRollup(res.group_data.aggregate.count)
        rollupNextKey.current = res.next_key
        setRollupNextKeyData(res.next_key)
        if (rollupCurrentGroupIndex.current === 0 && res.next_key) {
          rollupGroupSize.current = res.group_data.aggregate.count
        }
      }
    },
  })

  const curTab = useMemo(() => {
    return tabList.find((item) => item.active)?.value
  }, [tabList])

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        <Title title={t('explorer_4')} icon={icon} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      <div className={styles.paginationWrap}>
        <BlockTitle title={t('explorer_150')}></BlockTitle>
        <div className={'gea_pagination_box gea_pagination_wrap'}>
          <MePaginationNew
            loading={curTab === 'hub' ? loading : rollupLoading}
            currentPage={curTab === 'hub' ? pageParams.page : pageParamsRollup.page}
            pageSize={curTab === 'hub' ? pageParams.limit : pageParamsRollup.limit}
            setPageParams={curTab === 'hub' ? setPageParams : setPageParamsRollup}
            total={curTab === 'hub' ? total : totalRollup}
            paginationPreAndNext={
              curTab === 'hub' ? hubPaginationPreAndNext : rollupPaginationPreAndNext
            }
            groupSize={curTab === 'hub' ? hubGroupSize.current : rollupGroupSize.current}
            groupIndex={
              curTab === 'hub' ? hubCurrentGroupIndex.current : rollupCurrentGroupIndex.current
            }
            prevKeyFn={() => {
              if (curTab === 'hub') {
                if (loading) return
                if (hubCurrentGroupIndex.current === 0) return
                if (hubCurrentGroupIndex.current > 0) {
                  hubCurrentGroupIndex.current--
                }
                setPageParams({
                  offset: 0,
                  limit: pageParams.limit,
                  page: 1,
                })
              } else {
                if (rollupLoading) return
                if (rollupCurrentGroupIndex.current === 0) return
                if (rollupCurrentGroupIndex.current > 0) {
                  rollupCurrentGroupIndex.current--
                }
                setPageParamsRollup({
                  offset: 0,
                  limit: pageParamsRollup.limit,
                  page: 1,
                })
              }
            }}
            nextKeyFn={() => {
              if (curTab === 'hub') {
                if (loading) return
                if (!hubNextKey.current) return
                hubCurrentGroupIndex.current++
                hubKeyArray.current[hubCurrentGroupIndex.current] = hubNextKey.current
                setPageParams({
                  offset: 0,
                  limit: pageParams.limit,
                  page: 1,
                })
              } else {
                if (rollupLoading) return
                if (!rollupNextKey.current) return
                rollupCurrentGroupIndex.current++
                rollupKeyArray.current[rollupCurrentGroupIndex.current] = rollupNextKey.current
                setPageParamsRollup({
                  offset: 0,
                  limit: pageParamsRollup.limit,
                  page: 1,
                })
              }
            }}
          />
        </div>
      </div>
      {/* <div className={styles.slideBtnWrap}>
        <SlideBtn btnList={tabList} setBtnList={setTabList}></SlideBtn>
      </div> */}
      {curTab === 'hub' ? (
        // hub
        <div className={styles.cardWrap}>
          {loading && <LoadingCom />}
          {txList.map((item) => (
            <CardInfo netType="hub" key={item.hash} cardData={item} />
          ))}
          {!loading && txList.length === 0 && <MeEmpty />}
        </div>
      ) : (
        // rollup
        <div className={styles.cardWrap}>
          {rollupLoading && <LoadingCom />}
          {txListRollup?.map((item) => (
            <CardInfo netType="rollup" key={item.hash} cardData={item as any} />
          ))}
          {!rollupLoading && txListRollup.length === 0 && <MeEmpty />}
        </div>
      )}
      <div className="footer_pagination">
        <MePaginationNew
          loading={curTab === 'hub' ? loading : rollupLoading}
          currentPage={curTab === 'hub' ? pageParams.page : pageParamsRollup.page}
          pageSize={curTab === 'hub' ? pageParams.limit : pageParamsRollup.limit}
          setPageParams={curTab === 'hub' ? setPageParams : setPageParamsRollup}
          groupSize={curTab === 'hub' ? hubGroupSize.current : rollupGroupSize.current}
          groupIndex={
            curTab === 'hub' ? hubCurrentGroupIndex.current : rollupCurrentGroupIndex.current
          }
          total={curTab === 'hub' ? total : totalRollup}
          paginationPreAndNext={
            curTab === 'hub' ? hubPaginationPreAndNext : rollupPaginationPreAndNext
          }
          prevKeyFn={() => {
            if (curTab === 'hub') {
              if (loading) return
              if (hubCurrentGroupIndex.current === 0) return
              if (hubCurrentGroupIndex.current > 0) {
                hubCurrentGroupIndex.current--
              }
              setPageParams({
                offset: 0,
                limit: pageParams.limit,
                page: 1,
              })
            } else {
              if (rollupLoading) return
              if (rollupCurrentGroupIndex.current === 0) return
              if (rollupCurrentGroupIndex.current > 0) {
                rollupCurrentGroupIndex.current--
              }
              setPageParamsRollup({
                offset: 0,
                limit: pageParamsRollup.limit,
                page: 1,
              })
            }
          }}
          nextKeyFn={() => {
            if (curTab === 'hub') {
              if (loading) return
              if (!hubNextKey.current) return
              hubCurrentGroupIndex.current++
              hubKeyArray.current[hubCurrentGroupIndex.current] = hubNextKey.current
              setPageParams({
                offset: 0,
                limit: pageParams.limit,
                page: 1,
              })
            } else {
              if (rollupLoading) return
              if (!rollupNextKey.current) return
              rollupCurrentGroupIndex.current++
              rollupKeyArray.current[rollupCurrentGroupIndex.current] = rollupNextKey.current
              setPageParamsRollup({
                offset: 0,
                limit: pageParamsRollup.limit,
                page: 1,
              })
            }
          }}
        />
      </div>
    </div>
  )
}

export default Transition
